<template lang="html">
<div class="accounts">
  <row>
    <div class="sl-col-4">
      <div class="sl-condition">
        <row>
          <div class="col-md-4">
            <div class="form-group">
              <el-input v-model="condition.search" :placeholder="$t('Placeholder.AccountSearch')" @keyup.native.enter="searchByCondition"></el-input>
            </div>
          </div>
        </row>
        <row>
          <div class="col-md-4">
            <div class="form-group">
              <el-select v-model="condition.status" placeholder="Status" clearable>
                <el-option v-for="item in statusOp" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-4 sm-margin">
            <div class="form-group">
              <sl-btn class="sl-btn-lightblue" :text="$t('Functional.confirm')" @click.native="searchByCondition"></sl-btn>
              <router-link class="sl-el-btn sl-btn-green" tag="el-button" :to="{ name: 'Add-New-Account' }" @click.native="$ga.event('Link', 'Create new account', 'Accounts')">+ {{$t('Views.Accounts.btn.add')}}</router-link>
            </div>
          </div>
        </row>
      </div>
    </div>
  </row>
  <row>
    <div class="sl-col-4">
      <div class="sl-body" v-loading="loading">
        <row class="sl-table-reload" v-show="reloadBtn">
          {{$t('Notify.errorMsg')}}
          <sl-btn class="sl-btn-lightblue" :text="$t('Functional.reload')" @click.native="reloadTable"></sl-btn>
        </row>
        <el-table :data="tableData" style="width: 100%" @sort-change="handleSortChange" border>
          <el-table-column min-width="150" :fixed="$store.state.userAgent.isPhone ? false : 'left'"  :show-overflow-tooltip="true" prop="username" :label="$t('Views.Accounts.table.username')"> </el-table-column>
          <el-table-column min-width="150" :show-overflow-tooltip="true" prop="name" :label="$t('Views.Accounts.table.name')"> </el-table-column>
          <el-table-column min-width="150" :show-overflow-tooltip="true" prop="phone" :label="$t('Views.Accounts.table.mobile')"> </el-table-column>
          <el-table-column min-width="150" :show-overflow-tooltip="true" prop="email" :label="$t('Views.Accounts.table.email')"> </el-table-column>
          <el-table-column min-width="150" :show-overflow-tooltip="true" prop="status" :label="$t('Views.Accounts.table.status')" :formatter="formatterStatus"> </el-table-column>
          <el-table-column min-width="150" :show-overflow-tooltip="true" prop="lastLoginTime" :label="$t('Views.Accounts.table.lastTime')" sortable='custom'> </el-table-column>
          <el-table-column min-width="150" :show-overflow-tooltip="true" prop="createTime" :label="$t('Views.Accounts.table.createdAt')" sortable='custom'> </el-table-column>
          <el-table-column min-width="150" :show-overflow-tooltip="true" prop="modifyTime" :label="$t('Views.Accounts.table.updatedAt')"> </el-table-column>
          <el-table-column min-width="150" :show-overflow-tooltip="true" prop="admin" :label="$t('Views.Accounts.table.admin')" :formatter="formatterAdmin"> </el-table-column>
          <el-table-column :min-width="$store.state.userAgent.isPhone ? 100 : 150" fixed="right" :label="$t('Table.actions')">
            <template scope="scope">
              <el-button size="small" class="sl-edit" @click="edit(scope.row.id)">{{$t('Table.edit')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-show="!reloadBtn" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="table.page" :page-sizes="[10, 20, 50, 100]" :page-size="table.per" layout="prev, pager, next, sizes, jumper, total" :total="table.total"> </el-pagination>
      </div>
    </div>
  </row>
</div>
</template>

<script>
import api from '../../../api'
import * as types from '../../../store/types'
export default {
  name: 'Accounts',
  data() {
    return {
      loading: false,
      tableData: [],
      table: this.$store.state.accounts.table,
      condition: this.$store.state.accounts.condition,
      statusOp: [
        {
          label: 'On',
          value: '1'
        },
        {
          label: 'Off',
          value: '2'
        }
      ],
      reloadBtn: false
    }
  },
  methods: {
    formatterAdmin(row, column) {
      return row.admin === '1' ? this.$tc('Functional.yes', 2) : this.$tc('Functional.no', 2)
    },
    formatterStatus(row) {
      return row.status === '1' ? 'ON' : 'OFF'
    },
    edit(id) {
      this.$ga.event('Link', 'Edit', 'Create new account')
      this.$router.push({
        name: 'Update-Account',
        params: {
          id: id
        }
      })
    },
    handleSizeChange(per) {
      this.table.per = per
      updateTable(this, initParams(this))
    },
    handleCurrentChange(page) {
      this.table.page = page
      updateTable(this, initParams(this))
    },
    handleSortChange({
      column,
      prop,
      order
    }) {
      this.table = {
        page: this.table.page,
        per: this.table.per,
        order: order === null ? '' : order === 'descending' ? 'DESC' : 'ASC',
        orderBy: prop === null ? '' : prop
      }
      updateTable(this, initParams(this))
    },
    searchByCondition() {
      this.$ga.event('Button', 'TableSearch', 'Accounts')
      updateTable(this, initParams(this))
    },
    reloadTable() {
      this.$ga.event('Button', 'Reload', 'Accounts')
      updateTable(this, initParams(this))
    }
  },
  created() {
    updateTable(this, initParams(this))
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'Update-Account') {
      this.$store.commit(types.InitAccountTable)
    }
    next()
  }
}

function updateTable(vm, params) {
  vm.loading = true
  api.FetchAccountsTable(params).then(res => {
    const result = res.data.data
    vm.table = {
      total: result.total,
      page: ~~result.page,
      per: ~~result.per,
      order: result.order,
      orderBy: result.orderBy
    }
    vm.tableData = result.list
    vm.reloadBtn = vm.loading = false
  }).catch(error => {
    console.log(error)
    vm.tableData = []
    vm.loading = false
    vm.reloadBtn = true
  })
}
// 初始化table请求接口的参数
function initParams(vm) {
  vm.$store.commit(types.SetAccountTable, {
    table: Object.assign({}, vm.table),
    condition: Object.assign({}, vm.condition)
  })
  const ts = Object.assign({}, vm.$store.state.accounts)
  let tb = JSON.parse(JSON.stringify(ts.table))
  let cd = JSON.parse(JSON.stringify(ts.condition))
  delete tb.total
  return Object.assign({}, tb, cd)
}
</script>
<style>
.accounts div.sl-body td .cell.el-tooltip {
  white-space: nowrap;
  word-break: break-all;
  text-overflow: ellipsis;
  width: 150px;
}

.accounts div.sl-body th .cell {
  white-space: nowrap;
  word-break: break-all;
  text-overflow: ellipsis;
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// accounts.vue?b01b237e